import { createReducer } from '@reduxjs/toolkit';
import { InvoiceState } from './types';
import { fetchInvoices, fetchOrgInvoices, generateOrgInvoice, publishInvoice, markInvoicePaid, fetchFacilityInvoices, fetchInvoiceDetails } from './actions';

const initialState: InvoiceState = {
  invoices: {
    results: [],
    count: 0,
  },
  orgInvoices: {
    results: [],
    count: 0,
  },
  invoiceDetails: {
    data: null,
    loading: false,
    error: null,
  },
  loading: false,
  error: null,
};

export const invoiceReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchInvoices.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchInvoices.fulfilled, (state, action) => {
      state.loading = false;
      // Depending on the API response structure, sometimes it might be nested or direct. 
      // The previous action was returning response.data which might be correct if apiCall wrapper logic.
      // Assuming action payload is InvoiceList
      state.invoices = action.payload as any;
    })
    .addCase(fetchInvoices.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    })
    .addCase(fetchOrgInvoices.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchOrgInvoices.fulfilled, (state, action) => {
      state.loading = false;
      state.orgInvoices = action.payload;
    })
    .addCase(fetchOrgInvoices.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    })
    .addCase(generateOrgInvoice.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(generateOrgInvoice.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(generateOrgInvoice.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    })
    .addCase(publishInvoice.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(publishInvoice.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(publishInvoice.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    })
    .addCase(markInvoicePaid.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(markInvoicePaid.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(markInvoicePaid.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    })
    .addCase(fetchFacilityInvoices.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchFacilityInvoices.fulfilled, (state, action) => {
      state.loading = false;
      state.invoices = action.payload as any;
    })
    .addCase(fetchFacilityInvoices.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    })
    .addCase(fetchInvoiceDetails.pending, (state) => {
      if (!state.invoiceDetails) {
        state.invoiceDetails = { data: null, loading: false, error: null };
      }
      state.invoiceDetails.loading = true;
      state.invoiceDetails.error = null;
    })
    .addCase(fetchInvoiceDetails.fulfilled, (state, action) => {
      if (!state.invoiceDetails) {
        state.invoiceDetails = { data: null, loading: false, error: null };
      }
      state.invoiceDetails.loading = false;
      state.invoiceDetails.data = action.payload;
    })
    .addCase(fetchInvoiceDetails.rejected, (state, action) => {
      if (!state.invoiceDetails) {
        state.invoiceDetails = { data: null, loading: false, error: null };
      }
      state.invoiceDetails.loading = false;
      state.invoiceDetails.error = action.payload as string;
    });
});
